import React, { useEffect, useState } from "react";
import { makeSideBarActive, checkUserActiveStatus } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Tab from "../../components/tab";
import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import Profile from "./profile";
import ServicesOffering from "./servicesOffering";
import Users from "./users";
import GeneralSettings from "./generalsettings";
import AwardsCertifications from "./awardsCertifications";
import { updateCompanySettings, getCustomerForUserId, updateAwardsAndCertifications, listUserDetailsForCustomer, getUserDetailsForCustomer, addNewCompanyUser, updateRateInEmail, edituserStatus , getProviderDomains} from "./services";
import { useLocation } from "react-router-dom";
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import NotificationAlert from '../../components/notification';
import { updateNotificationStatus } from "../../components/noticationTab/services";
import { getAPI } from "../../api/api";
import { REACT_APP_COMMON } from "../../utils/common";

function CompanySettings() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3);
  const BreadcrumsValues = ["Companies", "Settings"];
  const userLoginId = localStorage.getItem('loginId') || ''

  const location = useLocation()
  //vishnu
  const data: any = JSON.parse(localStorage.getItem("CompanySettings") || "") || {}
  //const {data} : any = location.state || ' '
  const { notificationsId }: any = location.state || ''
  const [customerId, setCustomerId] = React.useState<any>()
  const [companyType, setCompanyType] = React.useState<number>(0)
  const [selected, setSelected] = React.useState<number>(0)
  const [flag, setFlag] = React.useState<boolean>(false)
  const [profileData, setProfileData] = useState<any>()
  const [showRateInEmail, setshowRateInEmail] = useState<boolean>()
  const [defImage, setDefImage] = useState<string>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [companyName, setCompanyName] = useState<any>()
  const [userlist, setUserList] = useState<any>()
  const [userDetails, setUserDetails] = useState<any>()
  const [servicesOfferingsValues, setServicesOfferingsValues] = useState<any>()
  const [awardsData, setAwardsData] = useState<any>([])
  const [certificationData, setCertificationData] = useState<any>([])
  const [providerDomains, setProviderDomains] = useState<any>()
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()
  const [customerMetadata, setCustomerMetadata] = useState<any>()

  useEffect(() => {

    if (data) {
      setCompanyType(data.companyType)
      if (data.companyId) {
        setCustomerId(data.companyId)
        getUsersList(data.companyId)
        getCompanyDetails(data.companyId)
      }
      if (data.customerId) {
        setCustomerId(data.customerId)
        getUsersList(data.customerId)
        getCompanyDetails(data.customerId)
      }
    }
    getProviderDomainsList()
    
  }, [data.companyType, data.companyId])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
    setFlag(true)
  }
  const getProviderDomainsList = () => {
      
    getProviderDomains().then((response: any) => {
      if(response && response.status === 1){
        const list = response.data.map((item: any) => {
          return ({id: item.domain_id, name:item.domain_name})
        })       
        setProviderDomains(list)
      }
    }) 
  }
  const updateNotification = (notificationId: any) => {

    updateNotificationStatus(notificationId).then((response: any) => {
      if (response && response.status === "success") {
      }
    });
  };

  const getCompanyDetails = (userLoginId: string) => {
    getCustomerForUserId(userLoginId).then((response: any) => {
      if (response && response.status === 1) {
        // response.data[0].customer_metadata.googleLocation = [{id: "a46fd30b-6f2d-4edf-8667-1dc4bba6333f", name: "Pune, Maharashtra, India"}]
        setProfileData(response.data[0])
        setshowRateInEmail(response.data[0].customer_metadata.showRateInEmail)
        setDefImage(response.data[0].customer_metadata.image)
        setCompanyName(response.data[0].customer_metadata.companyName)
        setServicesOfferingsValues(response.data[0].customer_metadata.servicesAndOfferings)
        setCustomerMetadata(response.data[0].customer_metadata)
        setAwardsData(response.data[0].customer_metadata.awards && response.data[0].customer_metadata.awards !== undefined ? response.data[0].customer_metadata.awards : [])
        setCertificationData(response.data[0].customer_metadata.certifications && response.data[0].customer_metadata.certifications !== undefined ? response.data[0].customer_metadata.certifications : [])
      }
    })
  }

  const getUsersList = (customerId: string) => {
    listUserDetailsForCustomer(customerId).then((response: any) => {
      setUserList(response.data && response.data.length > 0 && response.data.filter((item: { active_status: number; }) => item.active_status > 3 && item.active_status !== 5 ))
    })
  }

  const updateCompany = (data: any) => {    
    let body = {
      "customerId": customerId,
      "customerMetadata": {
        "size": data.companySize.id,
        "website": data.website,
        "workWithRemote": data.workWithRemote,
        "linkedinId": data.linkedInurl,
        "profileUrl": data.ellowurl,
        "aboutCompany": data.description,
        "currencyType": data.currencyType,
        "roleDescription": data.role,
        'image': data.image,
        'googleLocations': data.googleLocations
      }
    }
    updateCompanySettings(body).then((response: any) => {
      
      if (response && response.status === 1) {
        mixpanelData('TG - Company profile updated', {
          'source': 'Recruiter updates company profile',
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'Profile link': body && body.customerMetadata && body.customerMetadata.profileUrl,
          'LinkedIn link': body && body.customerMetadata && body.customerMetadata.linkedinId,
          'Company Website': body && body.customerMetadata && body.customerMetadata.website,
          'Company size': body && body.customerMetadata && body.customerMetadata.size && body.customerMetadata.size.name,
          'Prefered Currency': body && body.customerMetadata && body.customerMetadata.currencyType,
          "workWithRemote": data && data.workWithRemote === 0 ? 'Yes' : 'No',

        })
        mixpanelData('New TG - Company profile updated', {
          'source': 'Recruiter updates company profile',
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'Profile link': body && body.customerMetadata && body.customerMetadata.profileUrl,
          'LinkedIn link': body && body.customerMetadata && body.customerMetadata.linkedinId,
          'Company website': body && body.customerMetadata && body.customerMetadata.website,
          'Company size': data && data.companySize && data.companySize.name,
          'Prefered currency': body && body.customerMetadata && body.customerMetadata.currencyType,
          "Work with remote": data && data.workWithRemote === 0 ? 'Yes' : 'No',
          "Locations": body.customerMetadata.googleLocations && body.customerMetadata.googleLocations.map((item: any) => {return item.name}),
          'Company id': customerId,
          'Company name': response && response.data[0].customer_metadata.companyName,
          'Company type': response && response.data[0].company_type === 1 ? 'Hirer' : 'Provider'
        })
        setMessage('Details saved successfully')
        displayNotification()
        getCompanyDetails(customerId)
      }
    })
  }

  const getUserDetails = (user_id: string) => {
    getUserDetailsForCustomer(user_id).then((response: any) => {
      setUserDetails(response.data[0].user_metadata)
    })
  }

  const addNewUser = (data: any) => {
    
    addNewCompanyUser(data).then((response) => {
      if (response && response.status === 1) {
        if(data.userId){
          mixpanelData('TG - Company user updated', {
            'distict_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'Company Name': companyName,
            'distinct_id': localStorage.getItem('Email'),
            'Company Type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
            'Name of the user': data.userMetadata && data.userMetadata.firstName + data.userMetadata.lastName,
            'email of the user': data.userMetadata && data.userMetadata.email,
            'Phone number' : data.userMetadata && data.userMetadata.phone ? data.userMetadata.phone : 'NA',
            'Designation of the user': data.userMetadata && data.userMetadata.designation
          })
          mixpanelData('TestCompany user updated', {
            'Recruiter email': localStorage.getItem('Email'),
            'Company name': companyName,
            'distinct_id': localStorage.getItem('Email'),
            'Company type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
            'Name of the user': data.userMetadata && data.userMetadata.firstName + " " +  data.userMetadata.lastName,
            'Email of the user': data.userMetadata && data.userMetadata.email,
            'Phone number' : data.userMetadata && data.userMetadata.phone ? data.userMetadata.phone : 'NA',
            'Designation of the user': data.userMetadata && data.userMetadata.designation,
          //  'Candidate loginid': data.userId,
            'Primary': response && response.data[0]  && response.data[0].primary,
            'Status': checkUserActiveStatus(response && response.data[0]  && response.data[0].activeStatus),
            'Company id': data.customerId
          })
        }else{
          mixpanelData('New TG - Company user added', {
            'Recruiter email': localStorage.getItem('Email'),
            'Company name': companyName,
            'distinct_id': localStorage.getItem('Email'),
            'Company type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
            'Name of the user': data.userMetadata && data.userMetadata.firstName + " " + data.userMetadata.lastName,
            'Email of the user': data.userMetadata && data.userMetadata.email,
            'Phone number' : data.userMetadata && data.userMetadata.phone,
            'Designation of the user': data.userMetadata && data.userMetadata.designation,
            'Candidate loginid': data.userId,
            'Primary': response && response.data[0]  && response.data[0].primary,
            'Status': checkUserActiveStatus(response && response.data[0]  && response.data[0].activeStatus),
            'Company id': data.customerId
          })
        }
        getUsersList(customerId)
        setMessage('Details saved successfully')
        displayNotification()
      } 
      if (response && response.status === '3') {
        setMessage('Different email domain founded')
        displayNotification()
      }
      if (response && response.status === '4') {
        setMessage('This email id already exists under a company , Please use a different email or an alias')
        displayNotification()
      } 
    })
  }

  const showrateInMail = (data: any) => {
    updateRateInEmail(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('TG - Company general settings updated', {
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter Email': localStorage.getItem('Email'),
          'Company Name': companyName,
          'Company Type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
          'Rate enabled': data.showRateInEmail ? 'Yes': 'No'
        })
        mixpanelData('TestCompany general settings updated', {
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'Company name': companyName,
          'Company type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
          'Rate enabled': data.showRateInEmail ? 'Yes': 'No',
          'Name of the user': response.data && response.data.customer_metadata && response.data.customer_metadata.firstName + " " + response.data.customer_metadata.lastName,
          'email of the user': response.data && response.data.customer_metadata && response.data.customer_metadata.workEmail,
          'Phone number' : response.data && response.data.customer_metadata && response.data.customer_metadata.phone,
          'Designation of the user': response.data && response.data.customer_metadata && response.data.customer_metadata.designation,
          'Company id': data.customerId
        })
        getCompanyDetails(customerId)

      }
    })
  }

  const editUserStatus = (data: any) => {
    edituserStatus(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData(`TG - user status changed to ${data.action}`, {
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter Email': localStorage.getItem('Email'),
          'Company Name': companyName,
          'Company Type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both'
        })
        mixpanelData(`Testuser status changed to ${data.action}`, {
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'Company name': companyName,
          'Company type': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
          'Name of the user': response && response.data.userName,
          'Email of the user': response && response.data.userEmail,
          'Phone number' : response && response.data.phoneNumber,
          'Designation of the user': response && response.data.designation,
       //   'Candidate loginid': response && response.data.loginId,
          'Primary': response && response.data.primary,
          'Status': checkUserActiveStatus(response && response.data.activeStatus),
          'Company id': data.customerId

        })
        getUsersList(customerId)
        setMessage('Details updated successfully')
        displayNotification()
      }
    })
  }

  const servicesOffering = (body: any) => {    
    updateCompanySettings(body).then((response: any) => {
      if (response && response.status === 1) {
    mixpanelData('TG - Service and Offerings updated', {
      'distinct_id': localStorage.getItem('Email'),
      'Recruiter email': localStorage.getItem('Email'),
      'company name': response.data[0] && response.data[0].customer_metadata && response.data[0].customer_metadata.companyName, 
      'type of company': response.data[0] && response.data[0].company_type === 1 ? 'Hirer' : response.data[0].company_type === 2 ? 'Provider' : 'Both',
      'status': response.data[0] && response.data[0].customer_status === 4 ? 'Approved' : response.data[0].customer_status === 5 && 'Rejected' ,
      'services': body.customerMetadata.servicesAndOfferings.jobRoles && body.customerMetadata.servicesAndOfferings.jobRoles.length > 0 && body.customerMetadata.servicesAndOfferings.jobRoles.map((item: any) => item.name),
      'domains' : body.customerMetadata.servicesAndOfferings.domains && body.customerMetadata.servicesAndOfferings.domains.length > 0 && body.customerMetadata.servicesAndOfferings.domains.map((item: any) => item.name),
      'Technology capabilities': body.customerMetadata.servicesAndOfferings.skills && body.customerMetadata.servicesAndOfferings.skills.length > 0 && body.customerMetadata.servicesAndOfferings.skills.map((item: any) => item.skillName)
    })
    mixpanelData('New TG - Service and Offerings updated', {
      'distinct_id': localStorage.getItem('Email'),
      'Recruiter email': localStorage.getItem('Email'),
      'Company name': response.data[0] && response.data[0].customer_metadata && response.data[0].customer_metadata.companyName, 
      'Type of company': response.data[0] && response.data[0].company_type === 1 ? 'Hirer' : response.data[0].company_type === 2 ? 'Provider' : 'Both',
      'Status': response.data[0] && response.data[0].customer_status === 4 ? 'Approved' : response.data[0].customer_status === 5 && 'Rejected' ,
      'Services': body.customerMetadata.servicesAndOfferings.jobRoles && body.customerMetadata.servicesAndOfferings.jobRoles.length > 0 && body.customerMetadata.servicesAndOfferings.jobRoles.map((item: any) => item.name),
      'Domains' : body.customerMetadata.servicesAndOfferings.domains && body.customerMetadata.servicesAndOfferings.domains.length > 0 && body.customerMetadata.servicesAndOfferings.domains.map((item: any) => item.name),
      'Technology capabilities': body.customerMetadata.servicesAndOfferings.skills && body.customerMetadata.servicesAndOfferings.skills.length > 0 && body.customerMetadata.servicesAndOfferings.skills.map((item: any) => item.skillName),
      'Company id': body.customerId
    })
        getCompanyDetails(customerId)
        setMessage('Details saved successfully')
        displayNotification()
      }
    })
  }

  const updateAwardCertifications = (data: any) => {
    
    updateAwardsAndCertifications(data).then((response) => {
      if (response && response.status === 1) {
    mixpanelData(`TG - Company awards and certifications ${data.action}`, {
      'distinct_id': localStorage.getItem('Email'),
      'Recruiter email': localStorage.getItem('Email'),
      'Company name': companyName,
      'Type of company': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
      'Type': data.section,
      'Certification/Award Number': data.section === 'award' ? data.customerMetadata.awards && data.customerMetadata.awards[0].awardNumber : data.customerMetadata.certifications && data.customerMetadata.certifications[0].certificationNumber,
      'Certification/Award Name': data.section === 'award' ? data.customerMetadata.awards && data.customerMetadata.awards[0].awardName : data.customerMetadata.certifications && data.customerMetadata.certifications[0].certificationName
    })
    mixpanelData(`New TG - Company awards and certifications ${data.action}`, {
      'distinct_id': localStorage.getItem('Email'),
      'Recruiter email': localStorage.getItem('Email'),
      'Company name': companyName,
      'Type of company': companyType === 1 ? 'Hirer' : companyType === 2 ? 'Provider' : 'Both',
      'Type': data.section,
      'Certification/Award number': data.section === 'award' ? data.customerMetadata.awards && data.customerMetadata.awards[0].awardNumber : data.customerMetadata.certifications && data.customerMetadata.certifications[0].certificationNumber,
      'Certification/Award name': data.section === 'award' ? data.customerMetadata.awards && data.customerMetadata.awards[0].awardName : data.customerMetadata.certifications && data.customerMetadata.certifications[0].certificationName,
      'Company id': data.customerId,
      'Status': 'Approved'
    })
        getCompanyDetails(customerId)
        if (response.message === "Certification Deleted Successfully" || response.message === "Award Deleted Successfully") {
          setMessage('Details deleted successfully')
          displayNotification()
        } else {
          setMessage('Details saved successfully')
          displayNotification()
        }
      }
    })
  }

  const Back = () => {
    setSelected((prev) => prev - 1)
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 4000)
  }


  const onClose = () => {
    setNotification(false)
  }

  useEffect(() => {

    viewedpageMixpanel();

    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

    getAPI( REACT_APP_COMMON +  '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

  }, [])



  return (
    <>
      <section className="dashboardWrapper">
        <SideMenu menu={menu} />
        <div className="dashboardContent">
          <DashboardHeader searchChange={undefined} title={BreadcrumsValues} />
          <div className="companySettingsTab">
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title="Profile">
                <Profile clickHandler={updateCompany} defaultValues={profileData} customerId={customerId} defImage={defImage} companyType={companyType}/>
              </Tab>
              {companyType !== 1 &&
                <Tab title="Services & Offering">
                  <ServicesOffering clickHandler={servicesOffering} customerId={customerId} defImage={defImage} companyName={companyName} defaultValues={servicesOfferingsValues} back={() => setSelected(0)} providerDomains={providerDomains} skillList={skillList} jobRolesList={jobRoleList} customerMetadata={customerMetadata}/>
                </Tab>}
              {companyType !== 1 &&
                <Tab title="Awards & Certifications">
                  <AwardsCertifications customerId={customerId} defImage={defImage} companyName={companyName} updateAwardCertifications={updateAwardCertifications} awardsData={awardsData} certificationData={certificationData} />
                </Tab>
              }
              <Tab title="Users">
                <Users usersList={userlist} customerId={customerId} back={Back} getUser={getUserDetails} addNewUser={addNewUser} companyName={companyName} defImage={defImage} editUserStatus={editUserStatus} defaultValues={userDetails} />
              </Tab>
              {companyType !== 2 &&
                <Tab title="General Settings">
                  <GeneralSettings showrateInMail={showrateInMail} customerId={customerId} companyName={companyName} defaultValues={showRateInEmail} defImage={defImage} />
                </Tab>
              }
            </TabStrip>
          </div>
        </div>
        {notification && <NotificationAlert onClose={onClose} closable={true} >
          {message}
        </NotificationAlert>}
      </section>
    </>
  );
}
export default CompanySettings;

